/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';
import { TProduction } from '../types';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IMintProductionSlice {
	isMintProductions: boolean;
	setIsMintProductions: (
		_isMintProductions: boolean
	) => void;
	currentStepMintProductions: number;
	setCurrentStepMintProductions: (
		_currentStepMintProductions: number
	) => void;
	selectedProductionsForMint: TProduction[];
	setSelectedProductionsForMint: (
		productions: TProduction[]
	) => void;
	selectedProjectForProductionsMint: string | null;
	setSelectedProjectForProductionsMint: (
		project: string | null
	) => void;

	selectedProducerForProductionsMint: string | null;
	setSelectedProducerForProductionsMint: (
		producerId: string | null
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
	isMintProductions: false,
	currentStepMintProductions: 0,
	selectedProductionsForMint: [],
	selectedProjectForProductionsMint: null,
	selectedProducerForProductionsMint: null,
};

export const createMintProductionsSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IMintProductionSlice
> = (set) => ({
	...initialState,
	// State initial
	isMintProductions: false,

	// Action
	setIsMintProductions: (_isMintProductions: boolean) =>
		set({ isMintProductions: _isMintProductions }),
	setCurrentStepMintProductions: (
		_currentStepMintProductions: number
	) =>
		set({
			currentStepMintProductions:
				_currentStepMintProductions,
		}),
	setSelectedProductionsForMint: (
		_selectedProductionsForMint
	) =>
		set({
			selectedProductionsForMint:
				_selectedProductionsForMint,
		}),
	setSelectedProjectForProductionsMint: (
		_selectedProjectForProductionsMint
	) =>
		set({
			selectedProjectForProductionsMint:
				_selectedProjectForProductionsMint,
		}),
	setSelectedProducerForProductionsMint: (
		_selectedProducerForProductionsMint
	) =>
		set({
			selectedProducerForProductionsMint:
				_selectedProducerForProductionsMint,
		}),
});
